import {yupResolver} from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  makeStyles,
  Menu,
  MenuItem,
  Select,
  Theme,
  Tooltip,
  Typography,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import managerGroupApi from "api/managerGroupApi";
import {useAppDispatch, useAppSelector} from "app/hooks";
import BACKGROUND from "assets/img/bg_student_edit.png";
import EMOJI from "assets/img/emoji.png";
import axios, {AxiosResponse} from "axios";
import CheckboxField from "components/FormFields/CheckboxField";
import InputField from "components/FormFields/InputField";
import {SelectField} from "components/FormFields/SelectFiled";
import {BASE_URL, TOKEN} from "constants/config";
import Picker, {SKIN_TONE_MEDIUM_DARK} from "emoji-picker-react";
import {
  fetchCategoryList,
  selectCategoryList,
} from "features/Admin/pages/ManagerCategory/managerCategorySlice";
import {
  fetchDataOptions,
  fetchListWorkTypes,
  selectListArea,
  selectListDepartment,
  selectListWorkTypes,
} from "features/Auth/options/optionsSlice";
import {ListOptions, ListResponseOptions} from "models/managerGroup";
import {CreateLesson} from "models/managerLesson";
import moment from "moment";
import React, {useEffect, useMemo, useState} from "react";
import {useController, useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";
import ReactPlayer from "react-player";
import {useLocation, useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import * as yup from "yup";
const schemaDraft = yup.object().shape({});

export default function ReupLesson() {
  const useStyles = makeStyles((theme: Theme) => ({
    loading: {
      zIndex: 99,
      backgroundColor: "rgba(255,255,255,0.8)",
      width: "100%",
      height: "100%",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      "& >div": {
        position: "absolute",
        top: "60%",
        left: "50%",
        transform: "translate(-60%,-50%)",
        "& .MuiCircularProgress-root": {
          display: "flex",
          margin: "0 auto",
        },
      },
    },
    background: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      "& >div> img": {
        objectFit: "cover",
        height: "100%",
        margin: "0 auto",
        width: "100%",
      },
    },
    percentage: {
      color: "#137bbd",
      fontSize: 18,
      marginBottom: 15,
    },
    root: {
      display: "flex",
      alignItems: "center",
      marginBottom: 5,
      width: "100%",
    },
    header: {
      color: "#004673",
      fontSize: 25,
      fontWeight: 700,
      marginBottom: 10,
      minWidth: 150,
    },
    title: {
      fontSize: 15,
      fontWeight: 600,
      width: "14%",
      [theme.breakpoints?.up("xl")]: {
        // fontSize: 15,
        width: "10%",
      },
    },
    selectArea: {
      padding: 6,
      backgroundColor: disableArea ? "#f8f4f4" : "#fff",
    },
    label: {
      padding: 5,
      color: "#999999",
      [theme.breakpoints?.down("md")]: {
        fontSize: 12,
      },
      [theme.breakpoints?.down("sm")]: {
        fontSize: 9,
      },
    },

    btn_create: {
      background: "linear-gradient(0deg, #10BCA7 0%, rgba(255, 239, 156, 0.9) 165.52%)",
      color: "#fff",
      borderRadius: 10,
      padding: "10px 15px",
      marginLeft: 10,
    },
    btn_draft: {
      background: "linear-gradient(360deg, #399BD9 0%, #83CFFF 172.67%)",
      color: "#fff",
      borderRadius: 10,
      padding: "10px 15px",
    },
    btn_cancel: {
      background: "linear-gradient(0deg, #FD5468 0%, rgba(255, 193, 200, 0.9) 169.32%)",
      color: "#fff",
      borderRadius: 10,
      padding: "5px 15px",
      marginTop: 30,
    },
    icon_emoji: {
      position: "absolute",
      bottom: 10,
      right: 10,
      "& >span >img": {
        width: 25,
        height: 25,
      },
    },
    form__video__wrapper: {
      backgroundColor: "#fff",
      width: "100%",
      height: 400,
      boxShadow: "0px 0px 4px rgba(168, 168, 168, 0.25)",
      borderRadius: 8,
      "&:hover": {
        backgroundColor: "#ECECEC",
        transition: "linear 0.3s all",
      },
      "& >input ": {
        display: "none",
      },
    },
    form__video__iconClose: {
      position: "absolute",
      right: 10,
      top: 10,
      zIndex: 99,
      backgroundColor: "#FFF",
      borderRadius: "50%",
      width: 25,
      height: 25,
      cursor: "pointer",
    },
    form__video__content: {
      cursor: "pointer",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      height: "100%",
      "& > span": {
        color: "#AAAAAA",
        fontSize: 13,
      },
    },
  }));
  const {t} = useTranslation();
  const schema = yup.object().shape({
    publishDate: yup.string().when("postNow", {
      is: false,
      then: yup.string().required(`${t("managerLesson.vuilongchonngaydang")}`),
    }),
    publishTime: yup.string().when("postNow", {
      is: false,
      then: yup.string().required(`${t("managerLesson.vuilongchongiodang")}`),
    }),
    lessionCategoryId: yup.string().required(`${t("managerLesson.vuilongchonchude")}`),
    lessionDescription: yup.string().required(`${t("managerLesson.vuilongchonmota")}`),
    lessionTitle: yup.string().required(`${t("managerLesson.vuilongnhaptenbaihoc")}`),
  });
  const listArea = useAppSelector(selectListArea);
  const listCategory = useAppSelector(selectCategoryList);
  const listWorkTypes = useAppSelector(selectListWorkTypes);
  const [isPostNow, setIsPostNow] = useState(false);
  const [isAll, setIsAll] = useState(true);
  const [disableArea, setDisableArea] = useState(false);
  const [disableDate, setDisableDate] = useState(false);
  const [disableTime, setDisableTime] = useState(false);
  const [disableWorkType, setDisableWorkType] = useState(false);
  const [infoLesson, setInfoLesson] = useState<any>();
  const [draft, setDraft] = useState(false);
  const navigate = useNavigate();
  const [openEmoji, setOpenEmoji] = useState<null | HTMLElement>(null);
  const [loading, setLoading] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const listDepartment = useAppSelector(selectListDepartment);
  const [errorVideo, setErrorVideo] = useState("");
  const [video, setVideo] = useState("");
  const [fileVideo, setFileVideo] = useState("");
  const [idDepartment, setIdDepartment] = useState({
    id: 0,
    name: "",
  });

  // const cancelFileUpload = useRef(null);

  const handleOpenEmoji = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpenEmoji(event.currentTarget);
  };
  const location = useLocation();
  useEffect(() => {
    setInfoLesson(location);
  }, []);

  const initialValues: CreateLesson = {
    postNow: false,
    isAll: false,
    publishDate: "",
    publishTime: "",
    hiddenDate: "",
    hiddenTime: "",
    lessionCategoryId: "",
    lessionDescription: infoLesson?.state?.decription || "",
    lessionTitle: infoLesson?.state?.name || "",
    areaId: "",
    workTypeId: "",
    isDraft: "N",
    departmentId: "",
    copyFilesFromLessonID: 0,
  };
  const {control, handleSubmit, setValue, getValues, reset} = useForm({
    defaultValues: useMemo(() => initialValues, [initialValues]),
    resolver: yupResolver(draft ? schemaDraft : schema),
  });
  const {
    field: {value, onChange, onBlur},
    fieldState: {invalid, error},
  } = useController({
    name: "areaId",
    control,
  });
  useEffect(() => {
    reset(initialValues);
  }, [reset, infoLesson]);

  const onEmojiClick = (event: any, emojiObject: any) => {
    setValue("lessionDescription", getValues().lessionDescription + emojiObject.emoji);
  };
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchDataOptions());
    dispatch(fetchCategoryList());
  }, []);

  useEffect(() => {
    if (isAll) {
      setValue("areaId", "");
      setValue("workTypeId", "");
      setValue("departmentId", "");
      setDisableArea(true);
      setDisableWorkType(true);
    } else {
      setDisableArea(false);
      setDisableWorkType(false);
    }
    if (isPostNow) {
      setValue("publishDate", "");
      setValue("publishTime", "");
      setDisableTime(true);
      setDisableDate(true);
    } else {
      setDisableTime(false);
      setDisableDate(false);
    }
  }, [isAll, isPostNow]);
  const classes = useStyles();
  const token = localStorage.getItem(TOKEN);

  const handleGetListWorkType = async (option: ListOptions) => {
    try {
      const res: ListResponseOptions<ListOptions> = await managerGroupApi.getWorkTypeByArea(
        option?.id
      );

      if (res.responseCode === "00") {
        dispatch(fetchListWorkTypes(res));
      }
    } catch (error) {}
  };

  const handleSubmitForm = async (value: CreateLesson) => {
    const newValue = {
      ...value,
      isDraft: draft ? "Y" : "N",
      isAll: value.isAll ? "Y" : "N",
      publishDate: value.postNow
        ? moment(new Date()).format("YYYY/MM/DD").split("/").join("")
        : value.publishDate.split("-").join(""),
      publishTime: value.postNow
        ? moment(new Date()).format("HH/mm").split("/").join("")
        : value.publishTime.split(":").join(""),
      hiddenDate: value.hiddenDate?.split("-").join(""),
      hiddenTime: value.hiddenTime?.split(":").join(""),
      copyFilesFromLessonID: infoLesson?.state?.id || 0,
    };
    const formData = new FormData();
    formData.append("publishDate", newValue.publishDate);
    formData.append("publishTime", newValue.publishTime);
    formData.append("expiryDate", newValue.hiddenDate);
    formData.append("expiryTime", newValue.hiddenTime);
    formData.append("isAll", newValue.isAll);
    formData.append("isDraft", newValue.isDraft);
    formData.append("lessionCategoryId", newValue.lessionCategoryId);
    formData.append("lessionDescription", newValue.lessionDescription);
    formData.append("areaId", String(newValue.areaId));
    formData.append("workTypeId", String(newValue.workTypeId));
    formData.append("departmentId", String(newValue.departmentId));
    formData.append("lessionTitle", newValue.lessionTitle);
    formData.append("copyFilesFromLessonID", newValue.copyFilesFromLessonID);
    setLoading(true);
    try {
      const res: AxiosResponse = await axios({
        method: "POST",
        url: `${BASE_URL}/lession/createLession`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        data: formData,
        onUploadProgress: (progressEvent) => {
          let percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (percent < 100) {
            setUploadPercentage(percent);
          }
        },
        // cancelToken: new CancelToken((cancel: any) => (cancelFileUpload.current = cancel)),
      });
      if (res.data.responseCode === "00") {
        setUploadPercentage(100);
        setTimeout(() => {
          setUploadPercentage(0);
        }, 1000);
        toast.success(`${t("managerLesson.taomoibaihocthanhcong")}`);
        navigate("/admin/manager-lesson");
        setLoading(false);
      } else {
        setUploadPercentage(0);
        toast.error(`${t("managerLesson.taobaihocthatbai")}`);
        setLoading(false);
        throw new Error("Create lesson is failed");
      }
    } catch (error) {}
  };
  return (
    <Box style={{position: "relative"}}>
      <Box>
        <Tooltip title="Quay lại">
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIosIcon style={{marginLeft: 7}} />
          </IconButton>
        </Tooltip>
      </Box>
      {loading && (
        <Box className={classes.loading}>
          <Box>
            <Typography variant="subtitle2" className={classes.percentage}>
              {t("managerLesson.dangtai")}
              {uploadPercentage}%
            </Typography>
            {/* <img src={LOADING} alt="LOADING" /> */}
            <CircularProgress style={{width: 50, height: 50}} />
            {/* <Box textAlign="center">
              <Button className={classes.btn_cancel}>Hủy bỏ</Button>
            </Box> */}
          </Box>
        </Box>
      )}
      <Box className={classes.background}>
        <Typography variant="subtitle2" className={classes.header}>
          {t("button.addnew").toUpperCase()}
        </Typography>
        <div>
          <img src={BACKGROUND} alt="BACKGROUND" />
        </div>
      </Box>
      <form onSubmit={handleSubmit(handleSubmitForm)}>
        <Box className={classes.root}>
          <Box className={classes.root} width="100%">
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerLesson.lichdang")}
            </Typography>
            <Box className={classes.root}>
              <Box width="30%">
                <InputField
                  control={control}
                  type="date"
                  label=""
                  name="publishDate"
                  disabled={disableDate}
                />
              </Box>
              <Box ml={2} mr={4} width="30%">
                <InputField
                  control={control}
                  type="time"
                  label=""
                  name="publishTime"
                  disabled={disableTime}
                />
              </Box>

              <CheckboxField
                name="postNow"
                label={t("managerLesson.dangngay")}
                control={control}
                handleChange={setIsPostNow}
              />
            </Box>
          </Box>
        </Box>
        <Box className={classes.root}>
          <Box className={classes.root} width="100%">
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerLesson.lichan")}
            </Typography>
            <Box className={classes.root}>
              <Box width="30%">
                <InputField control={control} type="date" label="" name="hiddenDate" />
              </Box>
              <Box ml={2} mr={4} width="30%">
                <InputField control={control} type="time" label="" name="hiddenTime" />
              </Box>
            </Box>
          </Box>
        </Box>
        {/* <Box className={classes.root}>
          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerLesson.phancap")}
            </Typography>
            <Box className={classes.root}>
              <Box width="25%">
                <FormControl
                  fullWidth
                  variant="outlined"
                  margin="dense"
                  size="small"
                  error={invalid}
                >
                  <InputLabel id="areaId" className={classes.label}>
                    {t("auth.area")}
                  </InputLabel>
                  <Select
                    labelId="areaId"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    className={classes.selectArea}
                    variant="outlined"
                    fullWidth
                    disabled={disableArea}
                    label={t("auth.area")}
                    inputProps={{
                      name: "areaId",
                      id: "areaId_label",
                    }}
                  >
                    {listArea?.map((option) => (
                      <MenuItem
                        key={option.id}
                        value={option.id}
                        onClick={() => handleGetListWorkType(option)}
                      >
                        <span>{option.name}</span>
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{error?.message}</FormHelperText>
                </FormControl>
              </Box>
              <Box ml={2} width="25%">
                <SelectField
                  name="departmentId"
                  label={t("auth.department")}
                  options={listDepartment.map(({id, title}) => ({
                    id,
                    name: title,
                  }))}
                  disabled={disableWorkType}
                  control={control}
                  handleClick={(option: any) => {
                    if (option.name !== "Sản Xuất") {
                      setValue("workTypeId", "");
                    }
                    setIdDepartment({
                      id: option.id,
                      name: option.title,
                    });
                  }}
                />
              </Box>
              <Box ml={2} mr={4} width="25%">
                <SelectField
                  name="workTypeId"
                  label={t("auth.workType")}
                  options={listWorkTypes.map(({workType}) => ({
                    id: workType.id,
                    name: workType.name,
                  }))}
                  disabled={
                    listDepartment?.filter((department) => department.title === "Sản Xuất")[0]
                      ?.id === idDepartment.id
                      ? false
                      : true
                  }
                  control={control}
                />
              </Box>

              <CheckboxField
                name="isAll"
                label="Tất cả"
                control={control}
                handleChange={setIsAll}
              />
            </Box>
          </Box>
        </Box> */}
        <Box className={classes.root}>
          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerLesson.chude")}
            </Typography>
            <Box className={classes.root}>
              <SelectField
                name="lessionCategoryId"
                label={t("managerLesson.chude")}
                options={listCategory}
                control={control}
              />
            </Box>
          </Box>
        </Box>

        <Box className={classes.root}>
          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerLesson.tenbaihoc")}
            </Typography>
            <Box className={classes.root}>
              <InputField
                name="lessionTitle"
                label={t("managerLesson.tenbaihoc") + "..."}
                control={control}
              />
            </Box>
          </Box>
        </Box>

        <Box className={classes.root}>
          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerLesson.mota")}
            </Typography>
            <Box className={classes.root}>
              <Box position="relative" width="100%">
                <InputField
                  name="lessionDescription"
                  label={t("managerLesson.mota")}
                  control={control}
                  rows={3}
                  multiline
                />
                <IconButton onClick={handleOpenEmoji} className={classes.icon_emoji}>
                  <img src={EMOJI} alt="EMOJI" />
                </IconButton>
                {openEmoji && (
                  <Menu
                    id="simple-menu"
                    anchorEl={openEmoji}
                    keepMounted
                    open={Boolean(openEmoji)}
                    onClose={() => setOpenEmoji(null)}
                    getContentAnchorEl={null}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "center",
                    }}
                    //  className={classes.menu}
                  >
                    <Picker
                      onEmojiClick={onEmojiClick}
                      disableAutoFocus={true}
                      skinTone={SKIN_TONE_MEDIUM_DARK}
                      groupNames={{smileys_people: "PEOPLE"}}
                      native
                    />
                  </Menu>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className={classes.root}>
          <Box className={classes.root}>
            <Typography variant="subtitle2" className={classes.title}>
              {t("managerLesson.video")}
            </Typography>
            {infoLesson && infoLesson.state && (
              <ReactPlayer
                url={infoLesson.state.videoUrl}
                controls={true}
                width="100%"
                height="100%"
                config={{file: {attributes: {controlsList: "nodownload"}}}}
                // Disable right click
                onContextMenu={(e: any) => e.preventDefault()}
              />
            )}
          </Box>
        </Box>
        <Box textAlign="right" mt={3}>
          <Button type="submit" className={classes.btn_draft} onClick={() => setDraft(true)}>
            {t("managerLesson.luunhap")}
          </Button>
          <Button type="submit" className={classes.btn_create} onClick={() => setDraft(false)}>
            {t("managerLesson.dangtin")}
          </Button>
        </Box>
      </form>
    </Box>
  );
}
